import React from "react";

export const ProductTileRowPlaceholder: React.FC<{
  gap?: React.CSSProperties["gap"];
  marginTop?: React.CSSProperties["marginTop"];
}> = ({ gap, marginTop }) => {
  return (
    <div
      className="h-[334px] w-full md:h-[338px] lg:h-[360px]"
      style={{ gap, marginTop }}
      data-test-id="product-tile-row-placeholder"
    />
  );
};

export const BrandTileRowPlaceholder: React.FC<{
  gap?: React.CSSProperties["gap"];
  marginTop?: React.CSSProperties["marginTop"];
}> = ({ gap, marginTop }) => {
  return (
    <div
      className="h-[432px] w-full md:h-[562px] lg:h-[540px]"
      style={{ gap, marginTop }}
    />
  );
};
